









































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import EntityType from '@/models/Shared/EntityType';
import { InactivityReportModule } from '@/store/modules/inactivityReport';

@Component({ name: 'InactivityReports' })
export default class InactivityReports extends GiganautVue {
  activeEntityTab = 0;

  headers = [
    { text: 'Name', value: 'name' },
    { text: 'Linked', value: 'secondaryLabel' },
    { text: 'Last activity', value: 'lastActivityAt', width: 140 },
    { text: 'Days since', value: 'daysSinceActivity', width: 110 },
    { text: 'Last owner', value: 'lastActivityOwner', width: 180 },
    { text: '', value: 'actions', sortable: false, width: 60 },
  ];

  get loading() { return InactivityReportModule.loading; }
  get response() { return InactivityReportModule.response; }
  get rows() { return this.response ? this.response.items : []; }

  get companiesLabel(): string { return this.Labels.companies || 'Companies'; }
  get locationsLabel(): string { return this.Labels.locations || 'Locations'; }

  get entityType(): EntityType {
    return InactivityReportModule.request.entityType;
  }

  // Lowercased plural for the result footer ("12 matching clients"). Lower-
  // casing the agency label keeps it grammatical in mid-sentence.
  get entityName(): string {
    switch (this.entityType) {
      case EntityType.Company: return this.companiesLabel.toLowerCase();
      case EntityType.Location: return this.locationsLabel.toLowerCase();
      case EntityType.Contact: return 'contacts';
      case EntityType.Opportunity: return 'opportunities';
      default: return 'entities';
    }
  }

  mounted() {
    const idx = this.indexForEntityType(InactivityReportModule.request.entityType);
    if (idx >= 0) this.activeEntityTab = idx;
  }

  indexForEntityType(t: EntityType): number {
    if (t === EntityType.Company) return 0;
    if (t === EntityType.Location) return 1;
    if (t === EntityType.Contact) return 2;
    if (t === EntityType.Opportunity) return 3;
    return -1;
  }

  entityTypeForIndex(i: number): EntityType {
    switch (i) {
      case 1: return EntityType.Location;
      case 2: return EntityType.Contact;
      case 3: return EntityType.Opportunity;
      default: return EntityType.Company;
    }
  }

  async onEntityTabChanged(idx: number) {
    const newType = this.entityTypeForIndex(idx);
    if (InactivityReportModule.request.entityType === newType) return;
    InactivityReportModule.patchRequest({ entityType: newType });
    // Re-run with the current filters against the new entity type so the user
    // doesn't have to click Apply again just to switch the entity dimension.
    if (InactivityReportModule.response) {
      await InactivityReportModule.run();
    }
  }

  navigateToEntity(id: string) {
    let path = '';
    switch (this.entityType) {
      case EntityType.Company: path = '/agency/companies/'; break;
      case EntityType.Location: path = '/agency/locations/'; break;
      case EntityType.Contact: path = '/agency/contacts/'; break;
      case EntityType.Opportunity: path = '/agency/opportunities/'; break;
      default: return;
    }
    this.$router.push(path + id);
  }

  formatDate(s: string | null | undefined): string {
    if (!s) return '-';
    return new Date(s).toLocaleString();
  }
}
